import React, { useState } from "react";
import "./FormCard.scss";
import { UpOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const FormCard = ({
  title,
  titleClassName = "",
  children,
  childrenClassName = "",
  style,
  className = "",
  childrenStyle,
  collapsible = false,
}) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`formCard ${isDarkMode ? "dark" : ""} ${className}`.trim()}
      style={!collapsed ? style : { ...style, height: 77 }}
    >
      {!!title && (
        <div className={`formCardTitle ${titleClassName}`.trim()}>{title}</div>
      )}
      {!!collapsible ? (
        <UpOutlined
          className="collapseIcon"
          onClick={() => setCollapsed(!collapsed)}
          style={!!collapsed ? { transform: "rotate(180deg)" } : {}}
        />
      ) : null}
      <div
        className={`childrenContainer ${childrenClassName}`.trim()}
        style={
          !collapsed
            ? { ...childrenStyle }
            : { visibility: "hidden", height: 0 }
        }
      >
        {children}
      </div>
    </div>
  );
};

export default FormCard;
